import { useMemo } from 'react';
import { formatAddress } from '@/shared/lib/formatAddress';
import { Address } from '@/shared/model/Address';

export const useAddressFormatter = (address?: Address) => {
    const formattedAddress = useMemo(() => (address ? formatAddress(address) : ''), [address]);

    return formattedAddress;
};
